module.exports = __webpack_public_path__ + "media/vidio_tef.3b4889a0.mp4";